const SHOW_BLOCKER = 'show:blocker';
const showBlocker = () => {
    return {
        type: SHOW_BLOCKER,
        payload: { block: true },
    }
}

const HIDE_BLOCKER = 'hide:blocker';
const hideBlocker = () => {
    return {
        type: HIDE_BLOCKER,
        payload: { block: false },
    }
}

export {
    SHOW_BLOCKER,
    HIDE_BLOCKER,
    showBlocker,
    hideBlocker,
}